export default __webpack_public_path__ + "static/media/fleet_list-01.925e460e.svg";